import {
  Box,
  Button,
  Grid,
  Link,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import LoadingButton from "components/LoadingButton";
import { MANAGE_WORKERS } from "navigation/CONSTANTS";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { downloadCwkCsv, uploadCwkCsv } from "services";
import { properCase } from "../../utils";

const useStyles = makeStyles((theme) => ({
  mainGrid: {
    paddingLeft: 39,
    paddingBottom: 39,
  },
  subTitle2: {
    paddingTop: 20,
    paddingBottom: 20,
  },
  fileName: {
    paddingLeft: 8,
    display: "inline-block",
  },
  successText: {
    color: theme.success,
  },
  errorText: {
    color: theme.palette.error.main,
  },
}));

export const UploadCwk = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();
  const [isUploading, setIsUploading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [msg, setMsg] = useState(undefined);
  const [msgDialog, setMsgDialog] = useState(false);
  const [isError, setIsError] = useState(false);
  const [tmplUrl, setTmplUrl] = useState(null);

  useEffect(() => {
    console.log("download tmpl useEffect...");
    downloadCwkCsv()
      .then((res) => {
        setTmplUrl(res);
      })
      .catch((err) => {
        console.log("Error during File download! Please try again!");
        setTmplUrl("");
      });
  }, []);

  const selectFile = (event) => {
    // Validation: If the selected file is not .csv, then clear the selection.
    let regex = new RegExp("(.*?).(csv)$");
    if (!regex.test(event.target.value.toLowerCase())) {
      event.target.value = "";
      return false;
    }
    console.log("selectFile called... files=", event.target.files);
    setSelectedFiles(event.target.files[0]);
    setMsg(undefined);
  };

  const upload = (event) => {
    console.log("upload called... files=", selectedFiles);
    setIsUploading(true);
    setMsg(undefined);
    uploadCwkCsv(selectedFiles)
      .then((res) => {
        console.log("File Upload successful!");
        setSelectedFiles(undefined);
        setIsUploading(false);
        setMsg("pgUploadCwk.success");
        setMsgDialog(true);
        setIsError(false);
      })
      .catch((err) => {
        console.log("Error during File upload! Please try again!");
        setIsUploading(false);
        setMsg("pgUploadCwk.error");
        setMsgDialog(false);
        setIsError(true);
      });
  };

  const navigateToReview = () => {
    history.push(MANAGE_WORKERS, { isManageWorkers: true });
  };

  return (
    <>
      <Grid container direction="row" justify="center" spacing={2}>
        <Grid item xs={12}>
          <Paper variant="outlined">
            <Grid item sm={11} md={10} lg={9} className={classes.mainGrid}>
              <Typography
                variant="h5"
                color="primary"
                className={classes.subTitle2}
              >
                {properCase(t("pgUploadCwk.title"))}
              </Typography>

              <div>
                <label htmlFor="btn-upload">
                  <input
                    id="btn-upload"
                    name="btn-upload"
                    style={{ display: "none" }}
                    type="file"
                    accept=".csv, text/csv"
                    onChange={selectFile}
                  />
                  <Button
                    className="btn-choose"
                    variant="outlined"
                    component="span"
                  >
                    {t("pgUploadCwk.chooseFile")}
                  </Button>
                </label>
                <Typography variant="body2" className={classes.fileName}>
                  {selectedFiles && selectedFiles.name
                    ? selectedFiles.name
                    : null}
                </Typography>
                <Box my={2}>
                  <LoadingButton
                    onClick={upload}
                    isLoading={isUploading}
                    disabled={!(selectedFiles && selectedFiles.name)}
                  >
                    {t("pgUploadCwk.btnUpload")}
                  </LoadingButton>
                </Box>
                {msg ? (
                  <>
                    {isError ? (
                      <Box my={2}>
                        <Typography
                          variant="body2"
                          className={
                            isError ? classes.errorText : classes.successText
                          }
                        >
                          {t(msg)}
                        </Typography>
                      </Box>
                    ) : null}
                    <Dialog
                      open={msgDialog}
                      onClose={navigateToReview}
                      disableBackdropClick
                    >
                      {/* <DialogTitle id="form-dialog-title">Hello</DialogTitle> */}
                      <DialogContent>
                        <DialogContentText>{t(msg)}</DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={navigateToReview} color="primary">
                          {t("pgAddWorker.btnOk")}
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </>
                ) : null}
              </div>
              {tmplUrl === null ? null : tmplUrl === "" ? (
                <Typography variant="body2">
                  {t("pgUploadCwk.errDownload")}
                </Typography>
              ) : (
                <Link href={tmplUrl}>{t("pgUploadCwk.lblDownload")}</Link>
              )}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

UploadCwk.propTypes = {};
